import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import Input from "../../components/common/Input";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import Modal from "../../components/common/Modal";
import DatosProveedor from "../../components/common/DatosProveedor";
import { useDispatch } from "react-redux";
import { initDataProveedorPreguntas_Ex,initDataProveedorPreguntas_Val,
  initDataProveedorPreguntasArray_Val} from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import "./styles.scss";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";
import Checkbox from "../../components/common/Checkbox";
import Validate from "../../utils/Validate";
const ProveedoresPreguntas = ({dataT, keyIndex, handleActualizarFicha, handleChangePaso}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });
  const [arrPerfiles, setArrPerfiles] = useState([]);
  const [arrClasificacion, setArrClasificacion] = useState([]);
  const [arrPais, setArrPais] = useState([]);
  const [arrDepartamento, setArrDepartamento] = useState([]);
  const [arrProvincia, setArrProvincia] = useState([]);
  const [arrDistrito, setArrDistrito] = useState([]);
  const [arrTipoDoc, setArrTipoDoc] = useState([]);
  const [infoModal, setInfoModal] = useState(null);
  const [arrPregunta, setArrPregunta] = useState([]); 
  const [data, setData] = useState(Validate.extraerAtributos(initDataProveedorPreguntas_Ex, dataT));
  const [validacion, setValidacion] = useState({preguntas:[]});

  useEffect(() => {    
    setData(Validate.extraerAtributos(initDataProveedorPreguntas_Ex, dataT));
    getPreguntas();
  }, [dataT]);
  useEffect(() => {
    getPreguntas();
  }, []);  
  const getPreguntas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','PREGUNTA'));
      if (response.ok && response.data && response.data.payload) {
        let preguntas = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        preguntas = preguntas.sort((a,b)=>Number(a.value)-Number(b.value));        
        setArrPregunta(preguntas);
      }
    } catch (ex) {
      console.log("Error al obtener preguntas", ex);
    }
  };
  useEffect(() => {
    if(arrPregunta.length>0){
      let preguntas = arrPregunta.map(obj=>{ let jsData = data.preguntas.find(el=>el.idpPregunta==obj.value);
                                          return {idpPregunta: obj.value, idpTipoPregunta: 'PREGUNTA', ...jsData}
                                        });
      data.preguntas = preguntas;
      handleChange("preguntas", preguntas);
    } 
  }, [arrPregunta]);
  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };
  
  const resetForm =() => {
    
  };
  const handleChange = (name, value, i) => {
    let jsonAd = {};    
    value = value.toUpperCase ? value.toUpperCase() : value;
    setData({ ...data, [name]: value });
    if(value instanceof Array){
      //let limpArr = Validate.limpiarArregloIdProveedor(value.map((obj) => Object.assign({},obj)));
      validacion[name][i]=false;
      setValidacion({ ...validacion, [name]: validacion[name]});
    }else{
      setValidacion({ ...validacion, [name]: false });
    }
    
  };
  const validarFormulario = () => {
    let resp = true;
    for (var name in Object.assign({},initDataProveedorPreguntas_Val,Validate.limpiarObjeto(data))) {
      //if (data.hasOwnProperty(name)){
        if(!data[name] ){
          validacion[name] = true;
          setValidacion({...validacion, [name]: true});
          resp = false;
          //break;
        }
        if(data[name] instanceof Array && name=='preguntas'){
          let i=0;
          for(let elem of data[name]){
            for (var name2 in Object.assign({},initDataProveedorPreguntasArray_Val,Validate.limpiarObjeto(elem))) {
              //if (elem.hasOwnProperty(name2)){
                if(!elem[name2]){
                  if((i>=0 && i<=6) 
                    || (i>=7 && (data[name][3].indRespuesta=='S' || data[name][4].indRespuesta=='S')) 
                    ){
                    if(name2!='comentario' ||
                      (name2=='comentario' && elem.indRespuesta=='S' && (i==1 || i==2)))
                    {
                      console.log("LOGG"+(validacion[name]));
                      (validacion[name])[i] = (validacion[name])[i]?(validacion[name])[i]:{};
                      ((validacion[name])[i])[name2] = true;
                      setValidacion({...validacion, [name]: validacion[name]});
                      resp = false;
                    }
                  }
                }
              //}             
            }
            i++;
          }
        }
         
      //}     
    }
    return resp;
  }
  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);
 

  const handleCloseModal = (value) => {
    setOpenAdd(value);
  };

  const handleChangeEnvioCorreo = (event) => {
    console.log('============', event)
  };

  const handleChangeEmail = (text) => {
    console.log('============', text);
    };


  const handleOpenAddModal = (tag) => {    
    setTagBody(tag);
    resetForm();
    setOpenAdd(true);
  };
  
  const handleShowModal = (tag) => {
    setTagBody(tag);
    setInfoModal(true);
  };
  const bodyModal = (tag) => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">{tag=='PER'?'POLÍTICA DE PROTECCIÓN DE DATOS PERSONALES':'XXXXX'}</h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          <h4 className="title-05 margin-bottom-10">
            {tag=='PER'?`Conforme a lo establecido en la Ley N° 29733 - Ley de Protección de Datos Personales (la “Ley”) y en el Decreto Supremo 003-2013/JUS - Reglamento de la Ley (el “Reglamento”), 
              doy mi consentimiento libre, previo, informado, expreso e inequívoco, para que Rimac Seguros y Reaseguros (en adelante, RIMAC) realice el tratamiento de los datos personales que 
              le proporcione de forma física o digital (los “Datos Personales”), con la finalidad de ejecutar cualquier relación contractual que mantengo y/o mantendré con la misma, así como 
              para fines estadísticos y/o analíticos, y/o de comportamiento del cliente y/o para que evalúen la calidad del producto o servicio brindado. Declaro conocer mi derecho a revocar 
              este consentimiento en cualquier momento. Autorizo para los fines señalados, que RIMAC pueda realizar un tratamiento por encargo a terceros de mis Datos Personales, pudiendo transferirlos 
              a nivel nacional y/o internacional a las empresas subsidiarias, filiales, asociadas, afiliadas o miembros del Grupo Económico al cual pertenece RIMAC, además de otras empresas cuyo listado 
              completo se encuentra en la página web www.rimac.com.pe, sujetándose a las mismas obligaciones y medidas de seguridad, técnicas y legales. Declaro haber sido informado que conforme a la Ley 
              y el Reglamento, mientras dure mi relación contractual con RIMAC y hasta por 10 años de culminada la misma, mis Datos Personales se almacenarán en el banco de datos de Clientes de titularidad 
              de RIMAC, con domicilio en Av. Paseo de la República 3505 Piso 11 – San Isidro, Lima, estando además inscritos en el Registro Nacional de Protección de Datos Personales con la denominación 
              “Clientes” con código RNPDP-PJP N° 1637. Declaro conocer mi derecho a solicitar el acceso a mis Datos Personales y conocer su tratamiento, así como a solicitar su actualización, inclusión, 
              rectificación, cancelación y supresión, pudiendo oponerme a su uso o divulgación, a través de cualquiera de las Plataformas de Atención de RIMAC. Teniendo a salvo además el ejercicio de la 
              tutela de mis derechos ante la Autoridad Nacional de Protección de Datos Personales en vía de reclamación o al Poder Judicial para la acción de hábeas data.
              DERECHOS DE AUTOR: RIMAC INTERNACIONAL SE RESERVA TODOS LOS DERECHOS
                    
                    Este sitio Web se encuentra protegido por la normativa vigente sobre derechos de autor. Los derechos de autor en las páginas, en las pantallas que muestran las páginas, y en la información y materiales allí contenidos, así como la forma en que la información y los materiales están dispuestos, pertenecen a RIMAC Seguros y Reaseguros S.A. y RIMAC Entidad Prestadora de Salud, en adelante “RIMAC”, a menos que se indique algo distinto. En tal sentido, se encuentra expresamente prohibido, el empleo, modificación, reproducción, distribución o cualquier otro acto de disposición de los derechos de autor involucrados sin el consentimiento expreso de RIMAC, salvo en los casos permitidos por ley.
              DERECHOS DE PROPIEDAD INTELECTUAL - MARCAS REGISTRADAS

              RIMAC declara que “RIMAC Seguros y Reaseguros”, “RIMAC S.A. Entidad Prestadora de Salud”, “RIMAC Contigo”, “Aló RIMAC”, “RIMAC Soat” y “E-Taller RIMAC” son marcas de su exclusiva propiedad y se encuentran registradas en el Perú. RIMAC también reclama derechos sobre otras marcas registradas y marcas de servicio contenidas en este sitio Web. En tal sentido, se encuentra expresamente prohibido que dichas marcas sean copiadas, reproducidas, modificadas o utilizadas de cualquier manera que se afecten los derechos de propiedad intelectual que RIMAC tiene sobre ellas.
              USO DE INFORMACIÓN Y DE MATERIALES

              La información y los materiales contenidos en este sitio Web y cualquiera de sus páginas, así como los Términos y Condiciones que aquí aparecen se encuentran sujetos a cambios. RIMAC declara que realiza los mayores esfuerzos para brindar la información actualizada y exacta. Sin perjuicio de lo anterior, durante los procesos de actualización de la información de este sitio Web, los usuarios tendrán a su disposición las plataformas de atención al usuario y las centrales telefónicas de atención al cliente en donde podrán recibir toda la información actualizada de los productos y servicios que RIMAC ofrece. Se prohíbe estrictamente el uso no autorizado de este sitio Web y de los sistemas de RIMAC; incluyendo, pero no limitándose, al uso inapropiado de los nombres de usuarios y las contraseñas o de cualquier información que se presente en este sitio Web y cualquiera de sus páginas. Los productos y servicios mencionados en este sitio Web no están todos disponibles en todas las áreas geográficas, para tal efecto el usuario podrá consultar la disponibilidad de los productos a través de cualquiera de los canales de atención al cliente que RIMAC posee. La elegibilidad o asegurabilidad de cualquier persona o bien para productos y servicios mencionados en este sitio Web está sujeta a la determinación final de RIMAC.
              RESPONSABILIDAD DEL USUARIO

              Para el ingreso a la zona privada de clientes, es obligatorio completar el formulario de registro en todos sus campos con datos válidos para poder crear una cuenta en este sitio Web. El Usuario asume el compromiso de actualizar los datos personales conforme resulte necesario. Los Usuarios garantizan y responden, en cualquier caso, por la veracidad, exactitud, vigencia y autenticidad de los datos personales ingresados. El Usuario accederá a su cuenta personal mediante el ingreso de su nombre y clave de seguridad personal elegida (Contraseña). El Usuario se obliga a mantener la confidencialidad de su Clave de Seguridad. La Cuenta es personal, única e intransferible. El Usuario será responsable por el manejo de su Cuenta, pues el acceso a la misma está restringido al ingreso y uso de su Clave de Seguridad, de conocimiento exclusivo del Usuario. El Usuario se compromete a notificar a RIMAC en forma inmediata y por medio idóneo y fehaciente, cualquier uso no autorizado de su Cuenta, así como el ingreso por terceros no autorizados a la misma.
              ENLACES

              Este sitio Web puede contener enlaces a otros sitios Web controlados u ofrecidos por terceras personas (no relacionadas con RIMAC). RIMAC declara que no se hace responsable en relación a ninguna información, materiales, productos o servicios que aparezcan o que se ofrezcan en cualquiera de los sitios pertenecientes a terceras personas con enlaces a este sitio Web. Al crear un enlace al sitio Web de una tercera persona, RIMAC no apoya ni recomienda ningún producto o servicio que ésta ofrezca, ni tampoco ninguna información que ésta contenga. Tales sitios Web pueden tener unas condiciones y términos de uso y política de privacidad distinta a la de RIMAC así como proveer menos seguridad de la que ofrece el sitio Web de RIMAC.
              LÍMITES DE RESPONSABILIDAD POR FALLAS INFORMÁTICAS Y AFINES

              En ningún caso RIMAC se hará responsable por alguna clase de daño directo o indirecto, incidentales, pérdidas o gastos que surjan en relación a este sitio Web, o a cualquier otro sitio Web enlazado a éste, o en conexión al uso de éstos, debido a la falta de capacidad para usarlos o al mal manejo que pudiera realizar cualquier persona, debido a cualquier, interrupción, defecto, virus de computadora, demora en la operación, transición o falla del sistema.
              DISPONIBILIDAD

              Se encuentra prohibido el uso de este sitio Web por parte de cualquier persona para fines contrarios a las normas de orden público.
              TÉRMINOS ADICIONALES

              Ciertas secciones o páginas de este sitio Web pueden contener términos y condiciones que sean adicionales a los presente Términos y Condiciones de Uso que aquí se mencionan. En caso de conflicto, los términos y condiciones adicionales prevalecerán en las secciones o páginas donde aparezcan. En el supuesto que alguna de las disposiciones contenidas en los presentes Términos y Condiciones de Uso sea declarado ilegal, inválido o nulo, el resto de términos quedara vigente y aplicable para cualquier supuesto.
              LAS LEYES QUE RIGEN

              El uso de este sitio Web se regirá por todas las leyes aplicables de la República del Perú.

              © 2022 RIMAC Seguros y Reaseguros.`:'XXXXXXXXXXXXXXXXXXXXXXXXXX'}
            
          </h4>
        </div>
      </div>
    );
  };

  const fillEditForm = (row)=> {
    console.log(row);
      
  };
  
  const handleCloseAddModal = () => {
    setOpenAdd(false);
  };

     


  const handleSearchEndpoint = async () => {
    let payload = {
     
      
      
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.searchArea,
      fetchObj
    );
    dispatch(hideLoading());
    if (response.ok && response.data) {
      let { totalPages } = response.data;
      setPaginationData({ ...paginationData, totalPages: totalPages });

      let arrData =
        response &&
        response.data &&
        response.data.rows &&
        response.data.rows.map((item) => {
          let obj = {
            id: item.ID,
            dateTimeCreation: item.dateTimeCreation,
            name: item.name,
            email: item.email,
            emailRecepcion: item.emailRecepcion,
            estado: item.estado,
            sendMailValidation:  item.sendMailValidation? item.sendMailValidation: false,
            valEmailRecepcion:  item.valEmailRecepcion? item.valEmailRecepcion: false  
          };
          return obj;
        });
    } else {
      console.log("Error fetching data => ", response.message);
      
    }
  };

  return (
    <div className="step__content" data-key={keyIndex}>
      <div className="proveedores_content">
          <h4 className="title-05 margin-bottom-16 margin-top-16">
            <b>Preguntas Vinculadas a <span class="title-red">Cumplimiento:</span></b>
          </h4>
          {data.preguntas && data.preguntas.map((obj, index)=>
            (<>{((Number(obj.idpPregunta)>=1 && Number(obj.idpPregunta<=7)) 
              || ((Number(obj.idpPregunta)>=8  && (data.preguntas[3].indRespuesta=='S' || data.preguntas[4].indRespuesta=='S')))
              ) &&
            (<>
            <div className="d-justify-space-between d-flex-column-m w100 text-justify">                 
              <div className="documents_criteria_datos">
                <label htmlFor="idpPregunta">
                {index +1 +'. ' + arrPregunta.find(el=>el.value==obj.idpPregunta)?.text}
                </label>
              </div>                             
            </div>
            <div className="d-justify-space-between d-flex-column-m w100 ">
              <div className="documents_criteria_datos">               
                    <Radio
                        id={"indRespuesta"+index}
                        name={"indRespuesta"+index}
                        value="S"
                        onChange={(newValue) => { data.preguntas[index].indRespuesta = newValue;
                                                  handleChange("preguntas", data.preguntas, index);
                                                }}
                        isChecked={obj?.indRespuesta}
                        hasError= {validacion.preguntas[index] && validacion.preguntas[index].indRespuesta && '*'}
                    >
                        Si
                    </Radio>
                    <Radio
                        id={"indRespuesta"+index}
                        name={"indRespuesta"+index}
                        value="N"
                        onChange={(newValue) => { data.preguntas[index].indRespuesta = newValue;
                                                  handleChange("preguntas", data.preguntas, index);
                                                }} 
                        isChecked={obj?.indRespuesta}
                        hasError= {validacion.preguntas[index] && validacion.preguntas[index].indRespuesta && '*'}
                    >
                        No
                    </Radio>
                    <Input
                    label="Comentarios"
                    name="comentario"
                    maxLength="1000"
                    //hasError={(((index==1 || index==2) && data.preguntas[index].indRespuesta=='S' && (!data.preguntas[index].comentario || data.preguntas[index].comentario==''))?'Obligatorio':'')}
                    value={obj?.comentario}
                    onChange={(newValue) => { data.preguntas[index].comentario = newValue;
                                              handleChange("preguntas", data.preguntas, index);
                                            }}
                    hasError= {validacion.preguntas[index] && validacion.preguntas[index].comentario && '*'}                       
                  />
              </div>
            </div>  
            </>)
            }</>            
            )
          )
          }
          <div className="rd--file-card padding-20">
              <div className="d-justify-space-between d-flex-column-m w100 text-justify">
                <div className="documents_criteria_datos">
                El Proveedor se compromete a cumplir con los principios contenidos en la Política Anticorrupción y Código de Conducta de Rimac Seguros y Reaseguros S.A. disponibles en la web de RIMAC:
                <br/>
                <a href="https://www.rimac.com/sostenibilidad/cumplimiento?rfid=publica:home-sostenibilidad-cumplimiento:sostenibilidad:card" target="_blank">https://www.rimac.com/sostenibilidad/cumplimiento?rfid=publica:home-sostenibilidad-cumplimiento:sostenibilidad:card</a>
                 <br/>
                 Asimismo, declara conocer el Canal de Integridad mediante el cual podré denunciar cualquier acto irregular a los valores de integridad de Rimac (<a href="https://www.canaldeintegridad.com/linea_etica_breca/rimac" target="_blank">https://www.canaldeintegridad.com/linea_etica_breca/rimac</a>).
                </div>
              </div>
          </div>
          <br/>    
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_btns d-flex-end margin-bottom-16">
              <div className="documents_btnSearch">
                <Button
                  // type="submit"
                  primary
                  size="large"
                  onClick={()=>{
                    if(validarFormulario())
                        {
                          handleActualizarFicha(data);
                          handleChangePaso(keyIndex);
                        }
                  }}
                >
                  Continuar
                </Button>
              </div>                  
            </div>
          </div>
      </div>
      <div className="proveedores_margen">
        <DatosProveedor data={dataT}/>       
      </div>
      <Modal
        className="rd--modal-info-files"
        onToggle={(value) => setInfoModal(false)}
        visible={infoModal}
        width={672}
        fullScreenMobile
        redHoverClosed
        onLabelClosed
        max12Padding
        footer={
          <Button primary onClick={() => setInfoModal(false)}>
            Cerrar
          </Button>
        }
      >
        {bodyModal(tagBody)}
      </Modal>
    </div>
  );
};


export default ProveedoresPreguntas;
